// src/components/ui/Accordion.jsx
import React from "react";

const Accordion = React.memo(function Accordion({
  title,
  isOpen,
  onToggle,
  children,
  anchorId,
}) {
  return (
    <section id={anchorId} className="tab-section">
      <div className="accordion">
        <button
          type="button"
          className="accordion-header"
          onClick={onToggle}
          aria-expanded={isOpen}
        >
          <span>{title}</span>
          <span className={`chev ${isOpen ? "open" : ""}`}>▾</span>
        </button>

        {/* keep-mounted para no perder foco */}
        <div className={`accordion-body ${isOpen ? "open" : "collapsed"}`}>
          {children}
        </div>
      </div>
    </section>
  );
});

export default Accordion;


